import { TableCols } from "../interfaces/static-data";

export const ISSUERS: TableCols[] = [
  {
    key: 'longName',
    displayValue: 'Issuer Long Name',
    type: 'select'
  },
  {
    key: 'shortName',
    displayValue: 'Issuer Short Name',
  },
  {
    key: 'description',
    displayValue: 'Issuer Description',
  },
  {
    key: 'website',
    displayValue: 'Website',
  },
  {
    key: 'guarantor',
    displayValue: 'Guarantor',
  },
  {
    key: 'autocallProbOfLoss',
    displayValue: 'Autocall Prob Of Loss',
  },
  {
    key: 'poStartDate',
    displayValue: 'PO Start Date',
    mask: '0000-00-00',
  },
  {
    key: 'publicOfferAvail',
    displayValue: 'Public Offering Available',
  },
  {
    key: 'privatePlacementAvail',
    displayValue: 'Private Placement',
  },
  {
    key: 'advisedOnlyRestriction',
    displayValue: 'Advised Only Restriction',
  },
  {
    key: 'structuredDeposits',
    displayValue: 'Structured Deposits',
  },
  {
    key: 'comments',
    displayValue: 'Trading Comments',
  },
  {
    key: 'tier1Ratio',
    displayValue: 'Tier 1 Capital Ratio',
  },
  {
    key: 'tier1RatioReviewDate',
    displayValue: 'Date Reviewed (Tier 1)',
    mask: '0000-00-00',
  },
  {
    key: 'moodyRating',
    displayValue: "Moody's",
  },
  {
    key: 'moodyOutlook',
    displayValue: "Moody's Outlook",
  },
  {
    key: 'snpRating',
    displayValue: 'S&P',
  },
  {
    key: 'snpOutlook',
    displayValue: 'S&P Outlook',
  },
  {
    key: 'fitchRating',
    displayValue: 'Fitch',
  },
  {
    key: 'fitchOutlook',
    displayValue: 'Fitch Outlook',
  },
  {
    key: 'ratingsReviewDate',
    displayValue: 'Date Reviewed (Ratings)',
    mask: '0000-00-00',
  },
  {
    key: 'defaultRisk',
    displayValue: '1Y Def Risk',
  },
  {
    key: 'defaultProbability',
    displayValue: '1Y Def Prob',
  },
  {
    key: 'highestDefaultRisk',
    displayValue: 'Highest Risk',
  },
  {
    key: 'fiveYearCDS_model',
    displayValue: '5Y CDS (Model)',
  },
  {
    key: 'fiveYearCDS_1ylow',
    displayValue: '5Y CDS (1Y Low)',
  },
  {
    key: 'fiveYearCDS_1yhigh',
    displayValue: '5Y CDS (1Y High)',
  },
  {
    key: 'oneYearPriceVol',
    displayValue: '1Y Price Vol',
  },
  {
    key: 'riskReviewDate',
    displayValue: 'Date Reviewed (Risk)',
    mask: '0000-00-00',
  },
  {
    key: 'workflowStatus',
    displayValue: 'Workflow Status',
    hideOnForm: true
  },
  {
    key: 'lastUpdatedBy',
    displayValue: 'Last Updated By',
    hideOnForm: true
  },
  {
    key: 'deletedAt',
    displayValue: 'Updated On',
    hideOnForm: true
  }
];
